"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('loading', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M4,24 C4,35.045695 12.954305,44 24,44 L24,44 C35.045695,44 44,35.045695 44,24 C44,12.954305 35.045695,4 24,4",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 24 24;360 24 24",
    dur: "2.5s",
    repeatCount: "indefinite"
  })), _react.default.createElement("path", {
    d: "M36,24 C36,17.372583 30.627417,12 24,12 C17.372583,12 12,17.372583 12,24 C12,30.627417 17.372583,36 24,36 L24,36",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 24 24;0 24 24",
    dur: "2s",
    repeatCount: "indefinite"
  })))));
});

exports.default = _default;